import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, X } from "lucide-react";
import { useSite } from "../../context/SiteContext";

export const PreorderBanner = () => {
  const { site } = useSite();
  const b = site.banner;
  const key = `kmk-banner-hidden:${b.text}`;
  const [hidden, setHidden] = useState(() => sessionStorage.getItem(key) === "1");
  if (!b.enabled || !b.text || hidden) return null;
  const close = () => { sessionStorage.setItem(key, "1"); setHidden(true); };
  const inner = (
    <>
      <span>{b.text}</span>
      {b.link_url && <span className="hidden items-center gap-1 underline underline-offset-2 sm:inline-flex">{b.link_text || "Learn more"} <ArrowUpRight className="h-3.5 w-3.5" /></span>}
    </>
  );
  const cls = "flex items-center justify-center gap-2 px-10 py-2.5 text-center text-xs font-semibold sm:text-sm";
  return (
    <div className="relative bg-[#FF1F8E] text-white" data-testid="preorder-banner">
      {!b.link_url ? <div className={cls} data-testid="preorder-banner-text">{inner}</div>
        : b.link_url.startsWith("/") ? <Link to={b.link_url} className={cls} data-testid="preorder-banner-link">{inner}</Link>
        : <a href={b.link_url} target="_blank" rel="noreferrer" className={cls} data-testid="preorder-banner-link">{inner}</a>}
      <button onClick={close} aria-label="Close banner" className="absolute right-2 top-1/2 -translate-y-1/2 rounded-full p-1.5 hover:bg-white/20" data-testid="preorder-banner-close">
        <X className="h-4 w-4" />
      </button>
    </div>
  );
};
